import { render, staticRenderFns } from "./NoPlansDisclaimer.vue?vue&type=template&id=6b19cd5f&scoped=true"
var script = {}
import style0 from "./NoPlansDisclaimer.vue?vue&type=style&index=0&id=6b19cd5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19cd5f",
  null
  
)

export default component.exports